import 'focus-visible';
import SidebarMenuKeyboardNavigation from './sidebarMenuKeyboardNavigation';
import {
  sidebarMenu,
  sidebarMobileMenu,
  sidebarMenuToggleButton,
  sidebarMenuAlphaBackground,
  sidebarMobileMenuLevel1,
  sidebarMobileMenuLevel2List,
  sidebarMobileMenuScrollContainerList,
  documentHeader,
  atBody,
  atGrowler,
  atGrowlerBtn,
  atHeaderElements,
} from './global';
import {
  elementMenuToggleButton,
} from '../../menu/js/globals';

const ACTIVE_CLASS = 'active';
const NO_SCROLL_CLASS = 'no-scroll';
const SIDEBAR_MENU_HEADER_CLASS = 'at-sidebar-menu__header';
const BACKGROUND_COLOR_WHITE_CLASS = 'at-background-color--white';

const onTransitionEnd = (event) => {
  if (event.target === sidebarMobileMenuLevel1) {
    if (atGrowler) {
      atGrowler.style.zIndex = 'auto';
    }
    sidebarMenuToggleButton.style.zIndex = 'auto';
  }
};
const onTransitionStart = (event) => {
  if (event.target === sidebarMobileMenuLevel1) {
    if (atGrowler) {
      atGrowler.style.zIndex = '1050';
    }
    sidebarMenuToggleButton.style.zIndex = '1003';
  }
};

const closeMobileSidebarMenu = () => {
  atBody?.classList.remove(NO_SCROLL_CLASS);
  sidebarMenuToggleButton.setAttribute('aria-expanded', 'false');
  sidebarMenuToggleButton.classList.remove(ACTIVE_CLASS);
  sidebarMobileMenu.classList.remove(ACTIVE_CLASS);
  sidebarMenuAlphaBackground.classList.remove(ACTIVE_CLASS);
  sidebarMobileMenuLevel1.classList.remove(ACTIVE_CLASS);
  sidebarMobileMenuLevel1.classList.remove(BACKGROUND_COLOR_WHITE_CLASS);
  sidebarMobileMenuLevel1.style.top = '-200%';

  sidebarMobileMenuLevel2List.forEach((element) => {
    element.classList.remove(ACTIVE_CLASS);
    element.classList.remove(BACKGROUND_COLOR_WHITE_CLASS);
  });
  sidebarMenu.dataset.level = 0;
  // remove listeners
  sidebarMobileMenu.removeEventListener('keydown', SidebarMenuKeyboardNavigation.keydownHandler);
};

const openMobileSidebarMenu = () => {
  window.scroll({ top: 0 });
  documentHeader?.classList.add(SIDEBAR_MENU_HEADER_CLASS);
  atBody?.classList.add(NO_SCROLL_CLASS);
  sidebarMenuToggleButton.setAttribute('aria-expanded', 'true');
  sidebarMenuToggleButton.classList.add(ACTIVE_CLASS);
  sidebarMobileMenu.classList.add(ACTIVE_CLASS);
  sidebarMenuAlphaBackground.classList.add(ACTIVE_CLASS);

  const sidebarMenuToggleRect = sidebarMenuToggleButton.getBoundingClientRect();
  sidebarMobileMenuLevel1.classList.add(ACTIVE_CLASS);
  sidebarMobileMenuLevel1.style.top = `${sidebarMenuToggleRect.bottom}px`;
  sidebarMenu.dataset.level = 1;

  // to prevent rendering issues on the actual devices
  sidebarMobileMenuLevel1.classList.add(BACKGROUND_COLOR_WHITE_CLASS);

  // listeners
  sidebarMobileMenu.addEventListener('keydown', SidebarMenuKeyboardNavigation.keydownHandler);
};

const toggleMobileSidebarMenu = () => {
  if (sidebarMobileMenu.classList.contains(ACTIVE_CLASS)) {
    closeMobileSidebarMenu();
    return;
  }

  // If the search box is open, then first close it before opening mobile sidebar menu
  if (atHeaderElements.webSearchBtn && document.getElementById('web-search').classList?.contains(ACTIVE_CLASS)) {
    atHeaderElements.webSearchBtn.click();
    setTimeout(() => {
      openMobileSidebarMenu();
    }, 400);
    return;
  }

  // if the main header login button (logged users) is open in mobile screens - close it before opening mobile sidebar menu
  if (atHeaderElements.userProfileBtn && atHeaderElements.userProfileBtn.classList?.contains('at-user-button--active')) {
    atHeaderElements.userProfileBtn.click();
    setTimeout(() => {
      openMobileSidebarMenu();
    }, 400);
    return;
  }

  openMobileSidebarMenu();
};

const toggleMobileSidebarMenuLevel2 = (className) => {
  const element = document.querySelector(`.${className}`);

  if (!element) {
    return;
  }

  if (element.classList.contains(ACTIVE_CLASS)) {
    element.classList.remove(ACTIVE_CLASS);
    element.classList.remove(BACKGROUND_COLOR_WHITE_CLASS);
    sidebarMenu.dataset.level = 1;
    return;
  }

  window.scroll({ top: 0 });
  element.classList.add(ACTIVE_CLASS);
  element.classList.add(BACKGROUND_COLOR_WHITE_CLASS);
  sidebarMenu.dataset.level = 2;
  const sidebarMenuToggleRect = sidebarMenuToggleButton.getBoundingClientRect();
  element.style.top = `${sidebarMenuToggleRect.bottom}px`;
};

const setSideMobileMenuScrollHeight = () => sidebarMobileMenuScrollContainerList.forEach((element) => {
  const sidebarMenuToggleRect = sidebarMenuToggleButton.getBoundingClientRect();
  /* eslint-disable no-param-reassign */
  element.style.height = `${window.innerHeight - sidebarMenuToggleRect.bottom}px`;
});

class MobileSidebarMenu {
  static initialise() {
    window.addEventListener('orientationchange', closeMobileSidebarMenu);
    window.addEventListener('resize', setSideMobileMenuScrollHeight);
    sidebarMobileMenu.addEventListener('transitionend', onTransitionEnd);
    sidebarMobileMenu.addEventListener('transitionstart', onTransitionStart);

    if (!sidebarMenuToggleButton) {
      return;
    }

    // toggle menu listener (click)
    sidebarMenuToggleButton.addEventListener('click', () => {
      toggleMobileSidebarMenu();
    });

    atHeaderElements.webSearchBtn?.addEventListener('click', () => {
      if (sidebarMenuToggleButton.classList.contains(ACTIVE_CLASS)) {
        closeMobileSidebarMenu();
      }
    });

    atHeaderElements.userProfileBtn?.addEventListener('click', () => {
      if (sidebarMenuToggleButton.classList.contains(ACTIVE_CLASS)) {
        closeMobileSidebarMenu();
      }
    });

    elementMenuToggleButton?.addEventListener('click', () => {
      if (sidebarMenuToggleButton.classList.contains(ACTIVE_CLASS)) {
        closeMobileSidebarMenu();
      }
    });

    if (atGrowler) {
      atGrowlerBtn?.addEventListener('click', () => {
        closeMobileSidebarMenu();
      });

      const atGrowlerObserver = new ResizeObserver(setSideMobileMenuScrollHeight);
      atGrowlerObserver.observe(atGrowler);
    }
  }
}

if (sidebarMobileMenu) {
  MobileSidebarMenu.initialise();
}

export {
  // eslint-disable-next-line import/prefer-default-export
  toggleMobileSidebarMenuLevel2,
};
